<template>
    <dl class="goldtips-wrap">
        <dt class="cl-black fts-28">金币获取提示：</dt>
        <dd>1. 在社群发帖可获得金币，<a :href="HOST_BBS">快速进入</a></dd>
        <dd>2. 每日签到可获得金币，<a :href="HOST_BBS+'/plugin.php?id=dsu_paulsign:sign'">快速进入</a></dd>
        <dd>3. 分享猜涨跌的结果，可获得金币，要记得分享哟！</dd>
    </dl>
</template>
<script>
    import {HOST_BBS} from '../../const/index'
    export default {
        data() {
            return {
                HOST_BBS,
            }
        },
    }
</script>